module.exports = {"yes":"Oui","no":"Non"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Toggle/localization/fr-FR/strings.json
// module id = 1213
// module chunks = 0